<template lang="pug">
  .column.center.m4-bottom-15
    .row.space-between.middle.m4-bottom-6.max-content.m4-top-11
      h1.title-big.bolder
        | {{ $t('stats.title') }}
    .banner.column.center.middle.width-100.m4-bottom-6(v-if='isTrial || isFreemium')
      span.white.title-medium
        | {{ bannerText }}
      span.white.title-small.m4-top-2(v-if='isFreemium')
        | {{ $t('stats.notIncluded') }}
      router-link.secondary-button.m4-top-4(
        v-if='isFreemium'
        :to='{ name: routes.license }'
      )
        | {{ $t('stats.changeLicense') }}
    .column.max-content(v-if='userInfoLoaded')
      .row.m-bottom-4
        ability-development.m-right-2
        approach-by-category
      .row.space-between.m-bottom-5
        chosen-methodologies.m-right-2
        resources-more-valued
      carousel(
        :title='$t("stats.mostValuedResources")'
        :page='mostValuedResources.page'
        :totalPages='mostValuedResources.totalPages'
        @getNextPage='getMoreMostValuedResources',
        :loading='mostValuedResourcesLoading'
      )
        slide(v-for='resource in mostValuedResources.resources' :key='resource.id')
          resource-card.m-bottom-2(:resource='resource' :bookmarked='resource.isInAnyFolder')
</template>

<script>
import { mapState, mapActions } from 'vuex'

import AbilityDevelopment from '@/components/Statistics/AbilityDevelopment'
import ApproachByCategory from '@/components/Statistics/ApproachByCategory'
import ResourcesMoreValued from '@/components/Statistics/ResourcesMoreValued'
import ChosenMethodologies from '@/components/Statistics/ChosenMethodologies'
import ResourceCard from '@/components/ResourceCard'
import Carousel from '@/components/Carousel'

import userRole from '../mixins/userRole'
import { defaultPageSize } from '../utils/constants'
import { routes } from '../router'

export default {
  name: 'Stats',
  mixins: [userRole],
  data() {
    return { carrouselPageSize: defaultPageSize, routes }
  },
  async created() {
    this.hydrateStatistics()
  },
  computed: {
    ...mapState({
      mostValuedResources: state => state.statistics.mostValuedResources,
      mostValuedResourcesLoading: state => state.statistics.mostValuedResourcesLoading,
      userInfo: state => state.userInfo.userInfo
    }),
    userInfoLoaded() {
      return this.userInfo.primaryRoles
    },
    bannerText() {
      return this.isTrial ? this.$t('stats.trial') : this.$t('stats.simulatedMetrics')
    }
  },
  methods: {
    ...mapActions([
      'getLoggedUserInfo',
      'hydrateStatistics',
      'loadMostValuedResources'
    ]),
    toggleDownload() {
      this.showDownloadOptions = !this.showDownloadOptions
    },
    hideDownload() {
      this.showDownloadOptions = false
    },
    getMoreMostValuedResources({ pageNumber }) {
      this.loadMostValuedResources({
        pageNumber,
        pageSize: this.carrouselPageSize
      })
    }
  },
  components: {
    AbilityDevelopment,
    ApproachByCategory,
    ResourcesMoreValued,
    ChosenMethodologies,
    ResourceCard,
    Carousel
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/colors';
@import '../scss/variables/sizes';

.banner {
  background: url('../assets/bg_msg.svg') $blue center no-repeat;
  padding: 36px 0;
}

.actions {
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: 320px;
}
</style>
<style lang="scss">

.secondary-button {
  --max-width: 250px;
}
</style>
